export class BasePaysheet {
    id:number = 0;
    driver_id:number = 1;
    driver_name:string = "";
    expense_type_id:number = 13;
    expense_type_name:string = "";
    description:string = "";
    pay:number = 0;
    pay_date:Date = new Date();
    active: true;
}
